import { WhmThemeProvider } from "@securitize/reactjs-whm";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { I18nContextProvider } from "../../contexts/I18nContext";
import { MixPanelType } from "../../types/CommonTypes";
import MixPanelProvider from "../../contexts/MixPanelContext";

export interface MFEContainerProps {
  language: string;
  MixPanel: MixPanelType;
  children: React.ReactNode;
}

export default function MFEContainer({
  children,
  // language,
  MixPanel,
}: MFEContainerProps) {
  const queryProvider = new QueryClient({
    defaultOptions: {
      queries: {
        // We don't want to refetch every time the window is focused
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryProvider}>
      <MixPanelProvider MixPanel={MixPanel}>
        {/* <I18nContextProvider language={language}> */}
        <WhmThemeProvider>{children}</WhmThemeProvider>
        {/* </I18nContextProvider> */}
      </MixPanelProvider>
    </QueryClientProvider>
  );
}
